import { render, staticRenderFns } from "./AuditTrails.vue?vue&type=template&id=1c3a920d&scoped=true&"
import script from "./AuditTrails.vue?vue&type=script&lang=js&"
export * from "./AuditTrails.vue?vue&type=script&lang=js&"
import style0 from "./AuditTrails.vue?vue&type=style&index=0&id=1c3a920d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a920d",
  null
  
)

export default component.exports